import { unwrapForRead as e } from "./unwrap-for-read.js";
import { getResolvedRef as t, mergeSiblingReferences as n } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { isHidden as r } from "@scalar/workspace-store/helpers/is-hidden";
//#region src/schema/helpers/is-model-linkable.ts
var i = (i, { hideModels: a, document: o }) => {
	if (!i || a) return !1;
	let s = e(o)?.components?.schemas?.[i];
	return !r(t(s, n));
};
//#endregion
export { i as isModelLinkable };

//# sourceMappingURL=is-model-linkable.js.map